import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useAvatarColorList } from '@/modules/avatar/color/model/list';
import { useAvatarLayerList } from '@/modules/avatar/layer/model/list';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarImageEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const { colorOption, fetchList: fetchColors } = useAvatarColorList();
    const { layerOption, fetchList: fetchLayers } = useAvatarLayerList();
    const fetchAvatarItem = executeAction({
        request: () => avatarService.item.get(model.itemId),
        onSuccess: ({ data }) => {
            model.isItemPresent = true;
            model.itemName = data.name;
            model.categoryId = data.categoryId;
        },
        onError: () => {
            model.isItemPresent = false;
        }
    });

    const model = reactive({
        id: route.params.imageId,
        itemId: route.params.itemId,
        itemName: null,
        categoryId: null,
        colorId: null,
        layerId: null,
        isDefault: false,
        image: null,
        imageStatus: null,
        imageFile: null,
        canDelete: false,
        isItemPresent: false
    });

    const fetchAvatarItemImage = executeAction({
        canExecute: () => model.isItemPresent,
        request: () => avatarService.image.get(model.itemId, model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX, params: { itemId: model.itemId } })
    });

    onMounted(async () => {
        await Promise.all([fetchColors(), fetchLayers(), fetchAvatarItem()]);
        await fetchAvatarItemImage();
    });

    const actions = {
        update: excuteAndNotify({
            request: () =>
                avatarService.image.update(
                    model.itemId,
                    model.id,
                    model.colorId,
                    model.layerId,
                    model.isDefault,
                    model.imageFile
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX, params: { itemId: model.itemId } })
        }),
        remove: confirmAndRemove({
            request: () => avatarService.image.remove(model.itemId, model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.ITEM.IMAGE.INDEX, params: { itemId: model.itemId } })
        })
    };

    return { model, colorOption, layerOption, actions };
}
